import { Theme } from '@emotion/react';
import { BaseTheme, BreakPoints, ThemeProvider, useScreenClass } from '@triumph/design-system';
import { defaultsDeep } from 'es-toolkit/compat';
import React, { createContext, useContext } from 'react';
import CustomTheme from '../../../theme.json';

export interface AppContextProps {
    breakpoint: BreakPoints;
    theme: Theme;
}

export const AppContext = createContext<AppContextProps | undefined>(undefined);

export const useAppContext = () => {
    const context = useContext(AppContext);
    if (context === undefined) {
        throw new Error('useAppContext must be defined with a AppContext');
    }
    return context;
};

const AppContextProvider: React.FC<{
    children: React.ReactElement;
}> = ({ children }) => {
    const breakpoint = useScreenClass() as BreakPoints;

    const contextValue = {
        breakpoint,
        theme: defaultsDeep(CustomTheme, BaseTheme),
    };

    return (
        <AppContext.Provider value={contextValue}>
            <ThemeProvider theme={contextValue.theme}>{children}</ThemeProvider>
        </AppContext.Provider>
    );
};

export default AppContextProvider;
